<template>
  <v-tooltip
    top
    color="primary"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        ref="inputRef"
        v-bind="attrs"
        dense
        outlined
        validate-on-blur
        hide-details
        prefix="R$"
        :label="label"
        :filled="filled"
        :disabled="disabled"
        :readonly="readonly"
        :rules="rules"
        v-on="on"
        @change="$emit('input-changed', $event)"
      >
        <template
          v-if="mostrarIcones"
          v-slot:prepend
        >
          <icons
            :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
            :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
            @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
            @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
          />
        </template>
      </v-text-field>
    </template>

    <span>Número máximo permitido: 999.999.999.999,99</span>
  </v-tooltip>
</template>

<script>
import { watch } from '@vue/composition-api'
import { useCurrencyInput } from 'vue-currency-input'
import Icons from '@/views/formulario/componentes/Icons.vue'
import SubcomponenteBase from '@/views/formulario/subcomponentes/SubcomponenteBase.vue'

export default {
  components: {
    Icons,
  },

  extends: SubcomponenteBase,

  props: {
    value: {
      type: Number,
      default: null,
    },
  },

  setup(props) {
    const { inputRef, setValue } = useCurrencyInput({
      locale: 'pt-BR',
      currency: 'BRL',
      currencyDisplay: 'hidden',
      valueRange: {
        min: 0,
        max: 999999999999.99,
      },
      precision: {
        min: 2,
        max: 2,
      },
      hideCurrencySymbolOnFocus: true,
      hideGroupingSeparatorOnFocus: true,
      hideNegligibleDecimalDigitsOnFocus: false,
      autoDecimalDigits: true,
      useGrouping: true,
      accountingSign: false,
    })

    watch(() => props.value, value => { setValue(value) })

    return {
      inputRef,
    }
  },
}
</script>
